/* import __COLOCATED_TEMPLATE__ from './option.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
import { type ChildAction } from 'embercom/objects/inbox/command-k/action';
import { priorityLevelDisplay } from 'embercom/lib/inbox/priority-levels';

interface Args {
  actionItem: ChildAction;
}

interface Signature {
  Args: Args;
}

export default class SetPriorityLevelOption extends Component<Signature> {
  // The ChildAction's `value` is the integer level — read display metadata
  // (icon, colour, semantic class) here so the option template stays declarative.
  get display() {
    let value = this.args.actionItem.value;
    return priorityLevelDisplay(typeof value === 'number' ? value : 0);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::CommandK::SetPriorityLevel::Option': typeof SetPriorityLevelOption;
    'inbox2/command-k/set-priority-level/option': typeof SetPriorityLevelOption;
  }
}
